import React, { ReactElement } from 'react';
import { StatusCodes } from 'http-status-codes';
import { InvalidPermissionsPage } from 'b2b-apps/shop/common/components/InvalidPermissionsPage';
import { UnloggedUserPage } from 'b2b-apps/shop/common/components/UnloggedUserPage';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { WithNotPermittedHandler } from './withNotPermittedHandler.types';

const withNotPermittedHandler = <P, R extends RemoteRecord<any> = RemoteRecord<any>>(
  getRemoteRecords: (props: P) => R[],
): WithNotPermittedHandler<P> => (Component) => {
    const WithFailHandler = (props: P): ReactElement => {
      const remoteRecords = getRemoteRecords(props);

      for (const remoteRecord of remoteRecords.filter(record => record.hasFailed)) {
        if (remoteRecord.hasFailedWith(StatusCodes.UNAUTHORIZED)) {
          return <UnloggedUserPage />;
        }

        if (remoteRecord.hasFailedWith(StatusCodes.FORBIDDEN)) {
          return <InvalidPermissionsPage />;
        }
      }

      return <Component {...props} />;
    };

    return WithFailHandler;
  };

export { withNotPermittedHandler };
